import { useQuery } from '@tanstack/react-query';
import { workspacesApi } from '../api/workspaces';

/**
 * ADR-004: is the ACTIVE workspace a mysql mirror (asmx-owned, read-only)?
 * The shared form of the FixedAssetList idiom — hides write affordances while
 * the API 403s them anyway (defense in depth). Shares the ['workspaces']
 * react-query cache, so pages using it cost no extra request.
 */
export function useIsMirror(): boolean {
  const { data: workspaces } = useQuery({
    queryKey: ['workspaces'],
    queryFn: workspacesApi.list,
  });
  return workspaces?.find(w => w.isActive)?.sourceKind === 'mysql';
}
